import swal from "sweetalert"

class NewModalAlert {
  static success({
    title = "",
    text = "",
    confirmLabel = "teste4",
    onConfirm = () => {},
    onCancel = () => {},
  }) {
    swal({
      title,
      text,
      icon: "success",
      buttons: {
        cancel: {
          text: "salvar",
          visible: true,
        },
        confirm: {
          text: confirmLabel,
          value: true,
          visible: true,
          className: "confirm",
        },
      },
    }).then((value) => {
      if (value) {
        onConfirm()
      } else {
        onCancel()
      }
    })
  }

  static warn({
    title = "",
    text = "",
    confirmLabel = "Salvar",
    confirmButtonColor = "",
    hideConfirm = false,
    showCloseButton = true,
    onConfirm = () => {},
    onCancel = () => {},
  }) {
    swal({
      title,
      text,
      showCloseButton,
      icon: "warning",
      confirmButtonColor,
      buttons: {
        cancel: {
          text: "Sair sem salvar",
          visible: true,
        },
        confirm: {
          text: confirmLabel,
          value: true,
          visible: !hideConfirm,
          className: "warning",
        },
      },
    }).then((value) => {
      if (value) {
        onConfirm()
      } else {
        onCancel()
      }
    })
  }

  static danger({
    title = "",
    text = "",
    subititles = "",
    confirmLabel = "teste2",
    onConfirm = () => {},
  }) {
    swal({
      title,
      text,
      subititles,
      dangerMode: true,
      icon: "error",
      buttons: {
        cancel: {
          text: "Sair sem salvar",
          visible: true,
        },
        confirm: {
          text: confirmLabel,
          value: true,
          visible: true,
          className: "danger",
        },
      },
    }).then((value) => {
      if (value) {
        onConfirm()
      }
    })
  }

  static default({
    title = "",
    text = "",
    subititles = "",
    confirmLabel = "teste1",
    onConfirm = () => {},
  }) {
    swal({
      title,
      text,
      subititles,
      buttons: {
        cancel: {
          text: "Salvar",
          visible: true,
        },
        confirm: {
          text: confirmLabel,
          value: true,
          visible: true,
          className: "warning",
        },
      },
    }).then((value) => {
      if (value) {
        onConfirm()
      }
    })
  }
}

export default NewModalAlert
